<div class="page">
  <div class="content page-header">
    <h1 data-qa="page-title">Übersicht</h1>
    <div class="page-actions">
      @if (canCreateVorgang()) {
        <button
          (click)="openErstelleVorgangDialog()"
          data-qa="erstelle-vorgang-button"
          matButton="filled">
          <mat-icon>add</mat-icon>
          Vorgang hinzufügen
        </button>
      }
      @if (canCreateGesamtlastOrAbwurfpunkteVorgang()) {
        <button
          (click)="openCreateGesamtlastOrAbwurfpunkteDialog()"
          data-qa="batch-vorgang-button"
          matButton="filled">
          <mat-icon>queue</mat-icon>
          Batch-Vorgang
        </button>
      }
    </div>
  </div>
  <div class="content page-content">
    <ufla-aufgaben-list></ufla-aufgaben-list>
  </div>
</div>
